import React from 'react'
import { Card, CardHeader, Divider, FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material'
import { PropertyList } from '../../../../../components/PropertyList'
import CircularLoading from '../../../../../components/CircularProgress'
import { IMerchant } from '../../../../../types/merchant'

interface FilterGroupProps {
  isLoading: boolean
  merchant?: IMerchant
  updateMerchant?: (data: Partial<IMerchant>) => void
}

const menuItemsStatusType = [
  {
    label: 'ไม่ใช่',
    value: 0,
  },
  {
    label: 'ใช่',
    value: 1,
  },
]

const MerchantOrderDisplayCard = ({ isLoading, merchant, updateMerchant }: FilterGroupProps) => {
  return (
    <>
      <CircularLoading isLoading={isLoading} />
      <Card
        sx={{
          padding: 2,
        }}>
        <CardHeader title="การแสดงผลคำสั่งซื้อ (ผู้ใช้งานที่ไม่ใช่ ผู้ดูแลระบบ)" />
        <Divider />
        <PropertyList>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={6}>
              <FormControl variant="filled" fullWidth>
                <InputLabel id="ownerOrder-label">แสดงเฉพาะคำสั่งซื้อที่เป็นของตัวเอง</InputLabel>
                <Select
                  id="ownerOrder"
                  name="ownerOrder"
                  labelId="ownerOrder-label"
                  value={!!merchant?.config.display?.ownerOrder ? 1 : 0}
                  onChange={(e) => updateMerchant?.({
                    config: {
                      ...merchant?.config,
                      display: {
                        ...merchant?.config.display,
                        ownerOrder: !!e.target.value,
                      },
                    },
                  })}
                  fullWidth
                >
                  {
                    menuItemsStatusType.map((item) => (
                      <MenuItem value={item.value} key={item.value}>
                        {item.label}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} lg={6}>
              <FormControl variant="filled" fullWidth>
                <InputLabel id="totalOrder-label">แสดงผลรวมของคำสั่งซื้อ</InputLabel>
                <Select
                  id="totalOrder"
                  name="totalOrder"
                  labelId="totalOrder-label"
                  value={!!merchant?.config.display?.totalOrder ? 1 : 0}
                  onChange={(e) => updateMerchant?.({
                    config: {
                      ...merchant?.config,
                      display: {
                        ...merchant?.config.display,
                        totalOrder: !!e.target.value,
                      },
                    },
                  })}
                  fullWidth
                >
                  {
                    menuItemsStatusType.map((item) => (
                      <MenuItem value={item.value} key={item.value}>
                        {item.label}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} lg={6}>
              <FormControl variant="filled" fullWidth>
                <InputLabel id="social-label">แสดงโซเชียลในช่องที่อยู่</InputLabel>
                <Select
                  id="social"
                  name="social"
                  labelId="social-label"
                  value={!!merchant?.config.display?.social ? 1 : 0}
                  onChange={(e) => updateMerchant?.({
                    config: {
                      ...merchant?.config,
                      display: {
                        ...merchant?.config.display,
                        social: !!e.target.value,
                      },
                    },
                  })}
                  fullWidth
                >
                  {
                    menuItemsStatusType.map((item) => (
                      <MenuItem value={item.value} key={item.value}>
                        {item.label}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} lg={6}>
              <FormControl variant="filled" fullWidth>
                <InputLabel id="productPopular-label">แสดงสินค้าขายดี (รายงานลูกค้า)</InputLabel>
                {/* unset counts as shown — staff already saw this section before the setting existed */}
                <Select
                  id="productPopular"
                  name="productPopular"
                  labelId="productPopular-label"
                  value={merchant?.config.display?.productPopular !== false ? 1 : 0}
                  onChange={(e) => updateMerchant?.({
                    config: {
                      ...merchant?.config,
                      display: {
                        ...merchant?.config.display,
                        productPopular: !!e.target.value,
                      },
                    },
                  })}
                  fullWidth
                >
                  {
                    menuItemsStatusType.map((item) => (
                      <MenuItem value={item.value} key={item.value}>
                        {item.label}
                      </MenuItem>
                    ))
                  }
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </PropertyList>
      </Card>
    </>
  )
}

export default MerchantOrderDisplayCard
